// utils/referralUtils.ts

export interface ReferralData {
  referralSource?: string;
}

const REFERRAL_COOKIE_NAME = 'cfr_referral_data';
const COOKIE_EXPIRY_DAYS = 30;

export const getUrlParams = (): ReferralData => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    referralSource: urlParams.get('src') || urlParams.get('source') || urlParams.get('ref') || urlParams.get('referral') || undefined,
  };
};

export const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const saveReferralData = (referralData: ReferralData) => {
  const dataToSave = JSON.stringify(referralData);
  setCookie(REFERRAL_COOKIE_NAME, dataToSave, COOKIE_EXPIRY_DAYS);
};

export const loadReferralData = (): ReferralData | null => {
  const cookieValue = getCookie(REFERRAL_COOKIE_NAME);
  if (!cookieValue) return null;
  
  try {
    return JSON.parse(cookieValue);
  } catch (error) {
    console.warn('Failed to parse referral data from cookie:', error);
    return null;
  }
};

export const clearReferralData = () => {
  setCookie(REFERRAL_COOKIE_NAME, '', -1);
};

export const sanitizeReferralData = (data: ReferralData): ReferralData => {
  const sanitized: ReferralData = {};
  
  if (data.referralSource) {
    sanitized.referralSource = data.referralSource
      .replace(/[^a-zA-Z0-9_. -]/g, '')
      .substring(0, 100);
  }
  
  return sanitized;
};
